import dayjs from 'dayjs';
import { createStore } from 'zustand';

type ViewType = 'year' | 'month';

export type EventId = {
  startDate: string;
  endDate: string;
  clickedDate: string;
};

type CalendarStore = {
  selectedYear: number;
  selectedMonth: number;
  selectedViewType: ViewType;
  searchQuery: string;
  openedEventId: EventId | null;
  setOpenedEventId: (id: EventId | null) => void;
  selectYear: (year: number) => void;
  selectMonth: (month: number) => void;
  setViewType: (type: ViewType) => void;
  setSearchQuery: (search: string) => void;
};

const calendarStore = createStore<CalendarStore>((set) => ({
  selectedYear: dayjs().year(),
  selectedMonth: dayjs().month(),
  selectedViewType: 'month',
  searchQuery: '',
  openedEventId: null,
  setOpenedEventId: (id) => set({ openedEventId: id }),
  selectYear: (year) => set({ selectedYear: year }),
  selectMonth: (month) => set({ selectedMonth: month }),
  setViewType: (type) => set({ selectedViewType: type }),
  setSearchQuery: (search: string) => set({ searchQuery: search }),
}));

export default calendarStore;
